import { Select } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useCalculatorFinancial } from '../../../../store/calculator/financial';
import { getLang, getTranslations } from '../../../../translations';
import { TermsDataType } from '../../../../types/finance';
import { formatPercentage } from '../../../../utils/format';

interface FinanceTermsInterface {
    terms : TermsDataType
}

const FinanceTerms = ({terms} : FinanceTermsInterface) => {

    const calculator = useCalculatorFinancial();
    const lang = getLang();
    const trans = getTranslations();

    const ratesHandler = (event: React.SyntheticEvent<HTMLSelectElement, Event>) => {
        const key = (event.target as HTMLFormElement).value;

        if(terms)
            calculator.setDuration({month : key, rate : terms[key] as unknown as number});
    }

    return terms &&
        <Select label={trans.details.calculator.payment_financeMonths} onChange={(e) => ratesHandler(e)} defaultValue={Object.keys(terms)[Object.keys(terms).length - 1]}>
            {Object.keys(terms).map((key, i) => {
                    if(terms[key] == '-') return null;
                    const indexKey = `finance-term-${i}`;
                    const percentage = Number.parseFloat(terms[key as unknown as number]);
                    const formattedPercentage = formatPercentage(percentage, false, lang);
                    let text = trans.details.calculator.payment_finance_month;
                    text = text.replace('[mo]', key);
                    text = text.replace('[rate]', formattedPercentage);
                    return <option key={indexKey} value={key}>{text}</option>
                }
            )}
        </Select>;
}

export default FinanceTerms;
